import { handleFetchResponse } from '@noths/polaris-client-utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import fetch from 'isomorphic-fetch';
import getConfig from 'next/config';
import qs from 'querystring';

import { DeliveryPriceAndDateResponse, NextConfig } from 'src/types';
import { ReduxApplicationState } from '../combinedReducer';

const { publicRuntimeConfig } = getConfig() as NextConfig;

export type DeliveryZoneOptionsAPIResponse = DeliveryPriceAndDateResponse[];

export const requestDeliveryZoneOptions = createAsyncThunk<DeliveryZoneOptionsAPIResponse>(
  'deliveryZoneOptions/requestDeliveryZoneOptions',
  async (_, { getState }) => {
    const DELIVERY_OPTIONS_ENDPOINT = publicRuntimeConfig.endpoints.deliverySettings;
    const { product } = getState() as ReduxApplicationState;
    const { amount, currency } = product.price;

    const formattedAmount = new Intl.NumberFormat('en-GB', {
      style: 'decimal',
      minimumFractionDigits: 2,
    })
      .format(amount / 100)
      .replace(',', '');

    const querystring = qs.encode({
      amount: formattedAmount,
      currency,
    });

    const apiResponse = await fetch(
      `${DELIVERY_OPTIONS_ENDPOINT}v1/products/${product.code}/multiple-zone-delivery-options?${querystring}`,
    );

    const deliveryOptions: DeliveryZoneOptionsAPIResponse = await handleFetchResponse(apiResponse);

    return deliveryOptions;
  },
);
